import React from 'react';
import SeasonCard from './SeasonOverview';
import {recordedSeasonView} from './statSource';
import {FootballAnalyticsView} from '../football-intelligence/AnalyticsView';

export default function RecordedPlayerFallback({enabled,data,filters,onFilter}) {
 if(!enabled || data?.status!=='AVAILABLE')return null;
 return <section aria-label="Recorded player analytics">
  <h1>{data.profile?.name}</h1>
  <p className="fa-note">Showing recorded PitchAPI statistics. Current squad, availability and live match updates have not been verified here.</p>
  <SeasonCard seasonView={recordedSeasonView(data.season_summary)}/>
  <FootballAnalyticsView data={data} kind="player" embedded filters={filters} onFilter={onFilter}/>
 </section>;
}
